import { useEffect, useState } from "react";
import { configuredClicked } from "../ConfigureClickedFunction"

interface ICompareTable {
  items: Array<any>;
  travelDistance: number;
}

interface FilterValues {
  bearingfos?: number;
  drivefos?: number;
  bearingLifeMonths?: number;
}

const CompareTable = ({
  items,
  travelDistance
}: ICompareTable) => {
  const [filterValues, setFilterValues] = useState<FilterValues>({});
  const [filteredItems, setFilteredItems] = useState(items);

  useEffect(() => {
    let updatedItems = [...items];
    for (const [key, value] of Object.entries(filterValues)) {
      switch (key) {
        case "bearingfos":
          if (value) {
            updatedItems = updatedItems.filter((x) => x.bearingfos >= value);
          }
          break;
        case "drivefos":
          if (value) {
            updatedItems = updatedItems.filter((x) => x.drivefos >= value);
          }
          break;
        case "bearingLifeMonths":
          if (value) {
            updatedItems = updatedItems.filter(
              (x) => x.bearingLifeMonths >= value
            );
          }
          break;
        default:
          break;
      }
    }
    setFilteredItems(updatedItems);
  }, [items, filterValues]);

  return (
    <>
      <div className="comparison-table-container">
        <table className="comparison-table table">
          <thead>
            <tr>
              <th
                className="text-left font-black-bold stick-first-blue"
                style={{ minWidth: "200px" }}
              >
                Product Line
              </th>
              {filteredItems.map((item, index) => (
                <th key={index}>{item.product}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Size
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.systemSize}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                System Material
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.systemMaterial}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Bearing Type
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.bearingType}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Drive Type
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.drive}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Drive Details
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.driveDetails}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Repeatability (mm)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.repeatability}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Travel Per Input Turn (mm)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.leadOrPulleyCircumferenceM}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Theoretical Max Speed (m/s)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.criticalSpeedMS}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Shaft Speed (RPM)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.shaftSpeedRpm}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Shaft Accel. (rad/s^2)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.shaftPeakAccelerationRadSS}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Shaft Peak Torque (N-m)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.shaftPeakTorqueNm}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Shaft RMS Torque (N-m)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.shaftRmsTorqueNm}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                System Inertia (kg-m^2)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.systemInertia}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Bearing Factor of Safety
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.bearingfos}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white">
                Drive Factor of Safety
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>{item.drivefos}</td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-grey">
                Bearing Life (months)
              </td>
              {filteredItems.map((item, index) => (
                <td key={index}>
                  {item.bearingLifeMonths > 60 ? "60+" : item.bearingLifeMonths}
                </td>
              ))}
            </tr>
            <tr>
              <td className="text-left font-black-bold stick-first-white"></td>
              {filteredItems.map((item, index) => (
                <td key={index}>
                  <button
                    className="orange-button"
                    type="button"
                    onClick={() => configuredClicked(item, travelDistance)}
                  >
                    <i className="fas fa-wrench" style={{ color: "white" }}></i>{" "}
                    Configure
                  </button>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      <div className="text-left font-black-bold mt2">
        <div className="d-flex">
          <p className="mr-25" style={{ width: "250px" }}>
            {"Bearing Factor of Safety >="}
          </p>
          <input
            className="w-100px"
            type="number"
            onChange={(event) => {
              setFilterValues({
                ...filterValues,
                bearingfos: parseInt(event.target.value),
              });
            }}
          ></input>
        </div>
        <div className="d-flex">
          <p className="mr-25" style={{ width: "250px" }}>
            {"Drive Factor of Safety >="}
          </p>
          <input
            className="w-100px"
            type="number"
            onChange={(event) => {
              setFilterValues({
                ...filterValues,
                drivefos: parseInt(event.target.value),
              });
            }}
          ></input>
        </div>
        <div className="d-flex">
          <p className="mr-25" style={{ width: "250px" }}>
            {"Bearing Life (months) >="}
          </p>
          <input
            className="w-100px"
            type="number"
            onChange={(event) => {
              setFilterValues({
                ...filterValues,
                bearingLifeMonths: parseInt(event.target.value),
              });
            }}
          ></input>
        </div>
      </div>
    </>
  );
};

export default CompareTable;
